class SharedAbortController {
    private scenarioAbortControllers: Record<string, AbortController> = {
        'default': new AbortController()
    };
    private widgetAbortControllers: Record<string, Record<string, AbortController>> = {};

    getScenarioAbortController(playerId = 'default') {
        return this.scenarioAbortControllers[playerId];
    }

    getWidgetAbortController(widgetId: string, playerId = 'default') {
        return this.widgetAbortControllers[playerId]?.[widgetId];
    }

    setNewWidgetAbortController(widgetId: string, playerId = 'default') {
        if (!this.widgetAbortControllers[playerId]) {
            this.widgetAbortControllers[playerId] = {};
        }

        const existingController = this.widgetAbortControllers[playerId][widgetId];
        if (existingController) {
            existingController.abort();
        }
        this.widgetAbortControllers[playerId][widgetId] = new AbortController();
        return this.widgetAbortControllers[playerId][widgetId];
    }

    setNewScenarioAbortController(playerId = 'default') {
        const existingController = this.scenarioAbortControllers[playerId];
        if (existingController) {
            existingController.abort();
        }
        this.scenarioAbortControllers[playerId] = new AbortController();
        this.clearAndAbortWidgetRequest(playerId);
    }

    private clearAndAbortWidgetRequest(playerId = 'default') {
        const playerWidgets = this.widgetAbortControllers[playerId];
        if (playerWidgets) {
            Object.keys(playerWidgets).forEach((widgetId) => {
                try {
                    playerWidgets[widgetId]?.abort();
                } catch {
                    console.warn('Cannot abort request for widget:', widgetId, 'player:', playerId);
                }
            });
        }
        this.widgetAbortControllers[playerId] = {};
    }
}

const sharedAbortController = new SharedAbortController();

export { sharedAbortController };
